import React, { useState } from 'react';
import classes from './Navbar.module.scss';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/CloseOutlined';

const Navbar = () => {
  const [menuShow, setMenuShow] = useState(false);
  const menuClasses = [classes.Menu];
  if (menuShow) menuClasses.push(classes.Show);

  const navItems = [
    { value: 'Home' },
    { value: 'About' },
    { value: 'Projects' },
    { value: 'FAQ' },
  ]

  return (
    <div className={classes.Navbar}>
      <ul className={classes.NavList}>
        {navItems.map((item, i) => (
          <li key={i} className={classes.NavItem}>{item.value}</li>
        ))}
      </ul>

      <div className={classes.MenuIcon} onClick={()=> setMenuShow(true)}>
        <MenuIcon className={classes.Icon} color="inherit" fontSize="inherit" />
      </div>
      <div className={menuClasses.join(' ')}>
        <div className={classes.CloseIcon} onClick={()=> setMenuShow(false)}>
          <CloseIcon className={classes.Icon} color="inherit" fontSize="inherit" />
        </div>

        <ul className={classes.NavList}>
          {navItems.map((item, i) => (
            <li key={i} className={classes.NavItem} style={{
              transitionDelay: (200 * i) + 'ms'
            }}>{item.value}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Navbar;
